import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import ObjectViewer from '../Common/ObjectViewer';

const AdSet = () => {
  const dispatch = useDispatch();
  const { account_id, adset_id } = useParams();
  const { adSet, constructedTargetingObject } = useSelector((state) => state.general);

  const [targetingActionId, setTargetingActionId] = React.useState('69a45f25b7856b2e066f1eee');

  const adColumns = [
    {
      field: 'id',
      headerName: 'id',
      width: 200,
      renderCell: (params) => {
        return (
          <a href={`/ad/${account_id}/${params.row.id}`} target='_blank' rel='noreferrer'>
            {params.value}
          </a>
        );
      },
    },
    {
      field: 'name',
      headerName: 'name',
      width: 550,
    },
    {
      field: 'status',
      headerName: 'status',
      width: 200,
    },
  ];

  useEffect(() => {
    // dispatch(
    //   apiAction({ reduxField: 'allAccountData', route: 'accountDashboard/getAllAccountData', accountId: account_id })
    // );
    dispatch(
      apiAction({
        reduxField: 'adSet',
        route: 'accountDashboard/getAdSetById',
        accountId: account_id,
        adSetId: adset_id,
      }),
    );
  }, [dispatch, account_id, adset_id]);
  console.log({ adSet, constructedTargetingObject });
  return (
    <>
      <div>
        <Link className='btn btn-outline-dark' to={`/campaign/${account_id}/${adSet?.campaign_id}`}>
          Back to Campaign
        </Link>
      </div>
      <div className='mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <h3>AdSet Overview</h3>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
          <h5>
            AdSet Data from Facebook <span className='text-primary'>getAdSetById(adSetId, token)</span>
          </h5>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          {adSet?.id ? <ObjectViewer data={adSet} /> : <Spinner />}
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <div data-aos='fade-up' data-aos-delay='200'>
            {Array.isArray(adSet?.ads?.data) ? (
              <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
                <Box style={{ height: 600, width: '100%' }}>
                  <DataGrid
                    rows={adSet.ads?.data}
                    columns={adColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    //   checkboxSelection
                    disableSelectionOnClick
                  />
                </Box>
              </div>
            ) : (
              <Spinner />
            )}
          </div>
        </div>
        <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
          <input type='form-control' value={targetingActionId} onChange={(e) => setTargetingActionId(e.target.value)} />
          <button
            className='btn btn-outline-dark'
            onClick={() => {
              dispatch(
                apiAction({
                  reduxField: 'constructedTargetingObject',
                  route: 'accountDashboard/constructTargetingObject',
                  actionId: targetingActionId,
                  adset: adSet,
                }),
              );
            }}
          >
            Construct Targeting Object
          </button>
        </div>
      </div>
    </>
  );
};

export default AdSet;
